<template>
  <div class="user-card">
    <span class="img"><img :src="detail.avatar" alt=""></span>
    <span class="text">
      <span class="title">{{detail.nickname}}</span>
      <span class="desc">{{detail.studentNum}}个学生</span>
    </span>
    <span class="btn" @click="onClick()"><img src="./images/add.png" alt=""> 加入</span>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      nickname: String,
      studentNum: Number,
      avatar: String
    },
    onClick: Function
  }
}
</script>

<style scoped lang="less">
  .user-card {
    width: 360px;
  }
  .img {
    display: inline-block;
    width: 65px;
    height: 65px;
    margin-right: 10px;
    font-size: 0;
    position: relative;
    border: 2px solid #FFAD08;
    border-radius: 50%;
  }
  .img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
  .img::after {
    content: "";
    display: block;
    width: 24px;
    height: 24px;
    background: url("./images/vip.png")no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .text {
    display: inline-block;
    width: 130px;
    margin-right: 10px;
    vertical-align: 15px;
  }
  .title {
    display: block;
    font-weight: bolder;
    font-size: 15px;
    color: #5D5E5F;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .desc {
    font-size: 14px;
    color: #5D5E5F;
  }
  .btn {
    display: inline-block;
    width: 124px;
    height: 38px;
    background: #FF4D54;
    border-radius: 28px;
    color: #fff;
    text-align: center;
    line-height: 38px;
    vertical-align: 26px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      vertical-align: -3px;
      margin-right: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/usercard.vue